/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ terms: NonNullable<unknown>, expressions: NonNullable<unknown> }} Compliance_Pattern_Terms_And_ExpressionsInputs */



/**
* | output |
* | --- |
* | "{terms} terms and {expressions} expressions" |
*
* @param {Compliance_Pattern_Terms_And_ExpressionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_pattern_terms_and_expressions = /** @type {((inputs: Compliance_Pattern_Terms_And_ExpressionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Pattern_Terms_And_ExpressionsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.terms} Begriffe und ${i?.expressions} Ausdrücke`)
	return /** @type {LocalizedString} */ (`${i?.terms} terms and ${i?.expressions} expressions`)
});